import { Component, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { AuthenticationService } from "../../services/authentication.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { LucideAngularModule } from "lucide-angular";

@Component({
  selector: "app-logout",
  standalone: true,
  imports: [RouterModule, LucideAngularModule],
  templateUrl: "./logout.component.html",
  styleUrl: "./logout.component.css",
})
export class LogoutComponent implements OnInit {
  constructor(
    private authService: AuthenticationService,
    private localStorage: LocalStorageService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.authService.logout();
    this.localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^\s+/, "")
        .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
    });
    setTimeout(() => this.router.navigate(["/login"]), 3000);
  }

  navigateToLogin(): void {
    this.router.navigate(["/login"]);
  }

  navigateToRegister(): void {
    this.router.navigate(["/register"]);
  }
}
